import {
  AmazonKindleStore,
  AmazonStore,
  // AudibleStore,
  // GooglePlayStore,
  // IBookStore,
} from "../assets";
import { SubtitleWrapper, TitleWrapper } from "../components/Wrappers";

const TrustedStores = () => {
  const STORES = [
    {
      logo: AmazonStore,
      description: "Now available on Amazon",
    },
    {
      logo: AmazonKindleStore,
      description: "Now available on Kindle",
    },
    // {
    //   logo: IBookStore,
    //   description: "Now available on iBooks / Get your e-copy at iBooks",
    // },
    // {
    //   logo: AudibleStore,
    //   description: "Now available on Audible /  Get your e-copy at Audible",
    // },
    // {
    //   logo: GooglePlayStore,
    //   description:
    //     "Now available on Google play Books /  Get your e-copy at Google play Books",
    // },
  ];
  return (
    <div className="stores">
      <TitleWrapper
        secondaryTitle
        fontSize="24px"
        fontSizeSm="34px"
        textAlign="center"
        marginBottom="57px"
        marginBottomMd="50px"
        maxWidth="100%"
      >
        Trusted by the best
      </TitleWrapper>

      <div className="store__card__container">
        {STORES.map((store, i) => (
          <div key={i} className="store__card">
            <div className="store__logo">
              <img src={store.logo} alt="amazon" />
            </div>
            <SubtitleWrapper
              fontSize="18px"
              maxWidth="100%"
              lineHeight="30px"
              textAlign="center"
              marginTop="14px"
            >
              {store.description}
            </SubtitleWrapper>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustedStores;
